module.exports = __webpack_public_path__ + "static/media/conversation.2555ad56.png";